import HeaderDetailStyled from "components/OrderDetail/HeaderDetail/HeaderDetail.styled"
import SubHeaderDetailStyled from "components/OrderDetail/HeaderDetail/SubHeaderDetail.styled"
import { useTranslation } from "react-i18next"
import Skeleton from "react-loading-skeleton"
import { OderType, OrderShippingType } from "types/OrderType"
import { formatAdvanceDate } from "helpers/FormatDateHelper"
import { WebAppClientsEnum } from "enums/CommonEnum"
import { ShippingTypeEnum } from "enums/OrderEnum"
import { EShippinggroupStatus } from "enums/shippinggroupEmun"
import { useEnv } from "hooks"

const HeaderDetail = ({ order, sg }: { order: OderType; sg: OrderShippingType }) => {
  const { t } = useTranslation()
  const formatString = "dd-MM-yyyy HH:mm"
  const [_client] = useEnv().multiclient.get_user_env()

  const getCustomerContact = (): any => {
    const STORE_CHANNEL = "TIENDA";
    
    const isPrivilegeStore =
      _client === WebAppClientsEnum.privilege &&
      sg?.channel === STORE_CHANNEL;

    if (isPrivilegeStore && order?.shippingAddress?.contact) {
      const { name = "", lastName = "", ...rest } = order.shippingAddress.contact;
      return {
        ...rest,
        name: [name, lastName].filter(Boolean).join(" ").trim(),
      };
    }

    return order?.customer || {};
  };

  const customerContact = getCustomerContact()

  const showAlertPlanZero = (shippingGroupDetail: any) => {
    if(shippingGroupDetail?.custom?.planZero?.toUpperCase() === "SI" && shippingGroupDetail?.currentStatus?.tag === EShippinggroupStatus.confirmation){
      return (
        <SubHeaderDetailStyled>
          <div className="box-alert-styled inline">
            <p>⚠️ Para Planes Zero, NO se debe incluir la SIMCARD de Regalo</p>
          </div>
        </SubHeaderDetailStyled>
      )
    } else {
      return null
    }
  }

  return (
    <>
      <HeaderDetailStyled>
        <div className="header-oder-info">
          {customerContact?.name && <p className="relevant-title">{customerContact?.name|| <Skeleton width={200} />}</p>}
          {order?.customer?.id && <p>{order?.customer?.id || <Skeleton width={200} />} </p>}
          {customerContact?.email && <p>{customerContact?.email || <Skeleton width={200} />}</p>}
          {sg?.currentStatus?.date && (
            <p>
              Fecha de estado actual:{" "}
              {formatAdvanceDate(sg?.currentStatus?.date, formatString) || <Skeleton width={200} />}
            </p>
          )}
        </div>
        <div className="header-oder-info">
          {order?.shippingType ? (
            <p className="field">
              <span>Tipo de despacho:</span>
              <span className="relevant-title">{t(order.shippingType)} </span>
            </p>
          ) : (
            <p>
              <Skeleton width={200} />
            </p>
          )}

          {order?.deliveryType ? (
            <p className="field">
              <span>Tipo de entrega:</span>
              <span className="relevant-title">{t(order.deliveryType)} </span>
            </p>
          ) : (
            <p>
              <Skeleton width={200} />
            </p>
          )}
          {order?.salesChannelId ? (
            <p className="field">
              <span> ID canal ventas:</span>
              <span className="relevant-title">{order.salesChannelId} </span>
            </p>
          ) : (
            <p>
              <Skeleton width={200} />
            </p>
          )}

          {_client === WebAppClientsEnum.wom && order?.shippingType === ShippingTypeEnum.HD && (
            <p className="field">
              <span> Comuna:</span>
              <span className="relevant-title">{order?.shippingAddress?.location?.commune} </span>
            </p>
          )}
        </div>
      </HeaderDetailStyled>
      
      {showAlertPlanZero(sg)}
    </>
  )
}

export default HeaderDetail
